import axios from 'axios';

async function ObtenerRubros(prm_Activos: string = "") {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_rubros"
    
    const datosEnvio : { usuario: string; clave: string; activos?: string;}= {
        "usuario": "mpatti",
        "clave": "all2GetHer_!"
    };
    
    if (prm_Activos !== "") {
        datosEnvio['activos'] = prm_Activos;
    }

    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerRubros;